import React, { FC } from "react";

import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  width: string;
  height: string;
  fill?: string;
  className?: string;
}

const Dot: FC<Props> = ({ className, height, width, fill = colors.lapel }) => {
  return (
    <Svg
      className={className}
      height={height}
      width={width}
      viewBox="0 0 4 4"
      title="Dot icon"
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-20 -868)" fill={fill}>
          <circle cx="22" cy="870" r="2" />
        </g>
      </g>
    </Svg>
  );
};

export default React.memo(Dot);
